import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'

Vue.config.productionTip = false

// components
import BookmarkCards from './components/BookmarkCards'
import DataCard from './components/DataCard'
import NewsCards from './components/NewsCards'
import RssCard from './components/RssCard'
import RssCards from './components/RssCards'
import Sidebar from './components/Sidebar'
import Clock from './components/shared/Clock'
import Search from './components/shared/Search'
import Weather from './components/shared/Weather'

Vue.component('bookmarkcards', BookmarkCards)
Vue.component('datacard', DataCard)
Vue.component('newscards', NewsCards)
Vue.component('rsscard', RssCard)
Vue.component('rsscards', RssCards)
Vue.component('sidebar', Sidebar)
Vue.component('clock', Clock)
Vue.component('search', Search)
Vue.component('weather', Weather)

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
